import { h, render } from 'vue'

class DialogManager {
  constructor({ app, options }) {
    this.dialogs = {}
    this.app = app
    this.options = options || {}
  }

  scan() {
    // find all `*Dialog.vue` file  and register
    const context = import.meta.glob('../**/*Dialog.vue', { eager: true, import: 'default' })
    // console.log('DialogManagerPlugin: scanning dialogs...', context)
    let contextKeys = Object.keys(context)
    contextKeys.forEach((key) => {
      const dialogComponent = context[key]
      // extract dialog name from file path
      const nameMatch = key.match(/\/([^\/]+Dialog)\.vue$/)
      if (nameMatch && nameMatch[1]) {
        const dialogName = nameMatch[1]
        // console.debug(`DialogManagerPlugin: registering dialog '${dialogName}' from '${key}'`)
        this.dialogs[dialogName] = dialogComponent
      } else {
        console.warn(`DialogManagerPlugin: could not extract dialog name from path '${key}'`)
      }
    })
    return this.dialogs
  }

  openDialog(name, inputData = null, outputData = null) {
    return new Promise((resolve, reject) => {
      const DialogComponent = this.dialogs[name]
      if (!DialogComponent) {
        const error = new Error(`Dialog '${name}' not found`)
        console.error(error)
        reject(error)
        return
      }

      let mountPoint = document.getElementById('dialog-helper-mount-point');
      if (!mountPoint) {
        mountPoint = document.createElement('div');
        mountPoint.setAttribute('id', 'dialog-helper-mount-point');
        // Append to app element if possible, otherwise body
        const appElement = document.querySelector('[data-app="true"]');
        if (appElement) {
          appElement.appendChild(mountPoint);
        } else {
          document.body.appendChild(mountPoint);
        }
      }

      const instanceElement = document.createElement('div');
      mountPoint.appendChild(instanceElement);

      // Create VNode
      const vnode = h(DialogComponent, {
      })

      // Share App Context
      vnode.appContext = this.app._context

      // Render
      render(vnode, instanceElement)

      // Get instance
      const dialogInstance = vnode.component.proxy

      if (!dialogInstance || typeof dialogInstance.showDialog !== 'function') {
        render(null, instanceElement)
        instanceElement.remove()
        reject(new Error(`Dialog component '${name}' does not have a showDialog method`))
        return
      }

      // Call showDialog
      dialogInstance.showDialog(inputData, outputData)
        .then(result => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => {
          // Cleanup
          setTimeout(() => {
            render(null, instanceElement)
            instanceElement.remove()
          }, 100)
        })
    })
  }
}

export default {
  install(app, options) {
    const manager = new DialogManager({ app, options })
    manager.scan()
    app.config.globalProperties.$dialogManager = manager
  }
}

